<template>
  <div>
    <div class="form-all">
      <div class="win">
        <slot name="title"></slot>
        <div class="form">
          <form @submit.prevent="submit" class="form-main" ref="form">
            <!-- 所在城市 -->
            <tgo-city @exportValue="getValue" :regCity="regCity" ref="tgoCity" @setRegCity="setRegCity"></tgo-city>
            <!-- 所在企业 -->
            <div v-for="(item, index) in [infoConfig['company']]" :key="`c-${index}`">
              <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                <input
                slot="input"
                class="text-input"
                placeholder="请输入所在企业"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
              </form-item>
            </div>
            <!-- 职位 -->
            <div v-for="(item, index) in [infoConfig['job_title']]" :key="`j-${index}`">
              <form-item :item="item" :haveBorder="false" :iview="true" :ref="item.key" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="jobTitles"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <div v-if="info['job_title'] === '12'">
              <div v-for="(item, index) in [infoConfig['job_title_content']]" :key="`jt-${index}`" class="job-title-content">
                <span>{{item.subName}}</span>
                <form-item :item="item" :ref="item.key" @setOKList="setOKList" class="jtc-wrap">
                  <input
                  slot="input"
                  class="text-input"
                  placeholder="请输入职位名称"
                  type="text"
                  v-model="info[item.key]"
                  @focus="focusItem(item)"
                  @blur="blurItem(item)">
                </form-item>
              </div>
            </div>
            <!-- 行业领域 -->
            <div v-for="(item, index) in [infoConfig['company_industry']]" :key="`ci-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :multiple="true"
                :selects="companyIndustrys"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 融资阶段 -->
            <div v-for="(item, index) in [infoConfig['company_type']]" :key="`ct-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="companyTypes"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 企业规模人数 -->
            <div class="company-scale">
              <div v-for="(item, index) in [infoConfig['company_scale']]" :key="`cs-${index}`" class="scale">
                <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                  <tgo-select
                  slot="input"
                  :tkey="item.key"
                  :selects="companyScales"
                  @input="getValue"
                  @blur="blurItem(item)">
                  </tgo-select>
                </form-item>
              </div>
              <div v-for="(item, index) in [infoConfig['company_remark']]" :key="`cr-${index}`" class="remark">
                <form-item :item="item" :ref="item.key" @setOKList="setOKList">
                  <input
                  slot="input"
                  class="text-input"
                  placeholder="如：年收入5亿元，上轮融资13亿元"
                  type="text"
                  v-model="info[item.key]"
                  @focus="focusItem(item)"
                  @blur="blurItem(item)">
                </form-item>
              </div>
            </div>
            <!-- 企业研发团队规模人数 -->
            <div v-for="(item, index) in [infoConfig['company_develop']]" :key="`cd-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="companyDevelops"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 本人现带领团队规模人数 -->
            <div v-for="(item, index) in [infoConfig['managed_team_size']]" :key="`mts-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="managedTeamSizes"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 本人曾带领团队最大规模（人数） -->
            <div v-for="(item, index) in [infoConfig['development_team_size']]" :key="`dts-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <tgo-select
                slot="input"
                :tkey="item.key"
                :selects="managedTeamSizes"
                @input="getValue"
                @blur="blurItem(item)">
                </tgo-select>
              </form-item>
            </div>
            <!-- 从事研发工作起始年 -->
            <div v-for="(item, index) in [infoConfig['developed_start_year']]" :key="`dsy-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <DatePicker
                slot="input"
                type="year"
                :tKey="item.key"
                placeholder="请选择"
                @input="getValue"
                @focus="focusItem(item)"
                @blur="blurItem(item)"
                ></DatePicker>
              </form-item>
            </div>
            <!-- 从事管理工作起始年 -->
            <div v-for="(item, index) in [infoConfig['managed_start_year']]" :key="`msy-${index}`">
              <form-item :item="item" :ref="item.key" :iview="true" :haveBorder="false" @setOKList="setOKList">
                <DatePicker
                slot="input"
                type="year"
                :tKey="item.key"
                placeholder="请选择"
                @input="getValue"
                @focus="focusItem(item)"
                @blur="blurItem(item)"
                ></DatePicker>
              </form-item>
            </div>
            <!-- 工作经历 -->
            <div v-for="(item, index) in [infoConfig['work_experience']]" :key="`we-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input work-experience-input"
                :placeholder="item.placeholder"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)"></textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 职业成就 -->
            <div v-for="(item, index) in [infoConfig['achievements']]" :key="`A-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input achievements-input"
                :placeholder="item.placeholder"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)"></textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 教育经历 -->
            <div v-for="(item, index) in [infoConfig['study_experience']]" :key="`se-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input study-experience-input"
                :placeholder="item.placeholder"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
                </textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 可提供资源 -->
            <div v-for="(item, index) in [infoConfig['support_resource']]" :key="`sr-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input"
                placeholder="您愿意为其他学员提供哪些资源？例如：技术管理话题分享，九折购买本公司云服务、融资创业专业渠道与建议等。"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
                </textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 期望获得的价值 -->
            <div v-for="(item, index) in [infoConfig['want_resource']]" :key="`wt-${index}`">
              <form-item :item="item" :ref="item.key" form-item-style="textarea" @setOKList="setOKList">
                <textarea
                slot="input"
                class="textarea-input"
                placeholder="您希望通过 TGO 获得什么？例如：交流分享管理技术，学习软技能，拓展人脉等。请您尽量详细填写您的诉求"
                type="text"
                v-model="info[item.key]"
                @focus="focusItem(item)"
                @blur="blurItem(item)">
                </textarea>
                <div slot="input-extra" class="input-extra" v-if="!isNaN(remainNumber[item.key])">{{`还能输入${remainNumber[item.key]}字`}}</div>
              </form-item>
            </div>
            <!-- 是否愿意参与、组织学员交流活动 -->
            <div v-for="(item, index) in [infoConfig['willingness_to_participate']]" :key="`wtp-${index}`">
              <form-item :item="item" :ref="item.key" :haveBorder="false" @setOKList="setOKList">
                <div slot="extra2" class="subTitle">{{item.subTitle}}</div>
                <tgo-checkbox
                  slot="input"
                  :labels="item.labels"
                  :tkey="item.key"
                  :value="[1, 2]"
                  @input="getValue"
                  @focus="focusInput(item)"
                  @blur="blurItem(item)">
                </tgo-checkbox>
              </form-item>
            </div>
            <div class="submit">
              <div class="input" @click="submit">提交基本信息</div>
              <!-- <input type="submit" value="提交" hidefocus="true"> -->
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import infoConfig from './info-config'
// import { AutoComplete, Select, Option } from 'iview'
import tgoSelect from '@/components/form/select'
import DatePicker from '@/components/form/date-picker'
import formItem from '@/components/form/form.item'
import tgoCity from './linkSelect'
import tgoCheckbox from '@/components/form/checkbox'
import utils from '@/util'

// static 数据
import { jobTitles, companyIndustrys, companyTypes, companyScales, companyDevelops, teamSizes as managedTeamSizes } from '@/data/form'

export default {
  data () {
    let info = {}
    Object.keys(infoConfig).forEach(item => {
      if (infoConfig[item].type === 'gender') {
        infoConfig[item].labels.forEach(label => {
          if (label.checked) {
            info[item] = label.value
          }
        })
      } else if (infoConfig[item].type === 'checkbox') {
        info[item] = []
      } else {
        info[item] = ''
      }
    })
    info['country'] = ''
    info['province'] = ''
    info['city'] = ''
    info['willingness_to_participate'] = [1, 2]
    return {
      infoConfig,
      info,
      warn: {},
      valid: false,
      focusInputName: '',
      types: [],
      professionArea: [],
      wechat: '',
      sameWithPhone: false,
      remainNumber: {}, // 剩余字数
      regCity: true,
      // 静态数据引入
      jobTitles,
      companyIndustrys,
      companyTypes,
      companyScales,
      companyDevelops,
      managedTeamSizes
    }
  },
  components: {
    DatePicker,
    tgoSelect,
    formItem,
    tgoCity,
    tgoCheckbox
  },
  created () {
  },
  methods: {
    submit () {
      if (!Number.isNaN(parseInt(this.info['country'])) && !Number.isNaN(parseInt(this.info['province'])) && !Number.isNaN(parseInt(this.info['city']))) {
        this.regCity = true
      } else {
        this.regCity = false
        utils.toast('您填写的表单内容部分有误，请修改！')
        return
      }
      for (let key in this.infoConfig) {
        if (this.infoConfig[key].required) {
          this.blurItem(this.infoConfig[key])
        }
      }
      for (let key in this.warn) {
        if (this.warn[key] === false) {
          utils.toast('您填写的表单内容部分有误，请修改！')
          return
        }
      }
      this.$emit('submit', this.info)
    },
    blurItem (item) {
      this.$refs[item.key][0].blurFn(item, this.info)
    },
    focusItem (item) {
      this.$refs[item.key][0].focused = true
    },
    getValue (data) {
      this.info[data.key] = data.value
      // if (data.key === 'company_industry') {
      //   this.info[data.key] = [data.value]
      // } else {
      //   this.info[data.key] = data.value
      // }
    },
    /**
     * 存储已经符合规格的input的键值集合
     */
    setOKList (item) {
      if (item.warning.valid) {
        this.warn[item.key] = true
      } else {
        this.warn[item.key] = false
      }
    },
    /**
     * set city
     */
    setRegCity (v) {
      this.regCity = v
    },
    /**
     * 限制字数
     * @param {String} v 用户输入字数
     * @param {String} key 键值
     * @param {Number} number 限定字数
     */
    limitNumber (v, key, number) {
      if (v.length > number) {
        this.info[key] = this.info[key].slice(0, number)
        this.remainNumber[key] = 0
      } else {
        this.remainNumber[key] = number - v.length
      }
    }
  },
  computed: {
  },
  mounted () {
  },
  watch: {
    // 监测数值
    'info.company': {
      handler: function (n) {
        if (n.length > 50) {
          this.info['company'] = this.info['company'].slice(0, 50)
        }
      }
    },
    'info.company_remark': {
      handler: function (n) {
        if (n.length > 500) {
          this.info['company_remark'] = this.info['company_remark'].slice(0, 500)
        }
      }
    },
    'info.work_experience': {
      handler: function (n) {
        this.limitNumber(n, 'work_experience', 1000)
      }
    },
    'info.achievements': {
      handler: function (n) {
        this.limitNumber(n, 'achievements', 1000)
      }
    },
    'info.study_experience': {
      handler: function (n) {
        this.limitNumber(n, 'study_experience', 1000)
      }
    },
    'info.support_resource': {
      handler: function (n) {
        this.limitNumber(n, 'support_resource', 1000)
      }
    },
    'info.want_resource': {
      handler: function (n) {
        this.limitNumber(n, 'want_resource', 1000)
      }
    }
  }
}
</script>
<style lang="sass" scoped>
@import '../../../style/bulma/app.sass'

.fade-enter-active, .fade-leave-active
  transition: opacity .3s
.fade-enter, .fade-leave-to /* .fade-leave-active 在低于版本 2.1.8 中 */
  opacity: 0

input
  width: 100%
  &::-webkit-input-placeholder  /* WebKit, Blink, Edge */
    color: #bbbec4
    font-size: 12px
  &:-moz-placeholder  /* Mozilla Firefox 4 to 18 */
    color: #bbbec4
    font-size: 12px
  &::-moz-placeholder  /* Mozilla Firefox 19+ */
    color: #bbbec4
    font-size: 12px
  &:-ms-input-placeholder /* Internet Explorer 10-11 */
    color: #bbbec4
    font-size: 12px

.form-all
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  +mobile
    margin: 0
  .win
    width: 100%
    position: relative
    .form
      background-color: #fff
      .form-main
        .job-title-content
          span
            display: block
            font-size: 14px
            color: #353535
            padding: 0 0 8px 48px
            line-height: 1
          .jtc-wrap
            width: 60%
          +mobile
            span
              padding-left: 0
            .jtc-wrap
              width: auto
        .company-scale
          display: flex
          justify-content: space-between
          +mobile
            display: block
          .scale
            flex-grow: 1
          .remark
            flex-grow: 1
            margin-left: 15px
            margin-top: 44px
            +mobile
              margin-left: 0
              margin-top: 12px
        .submit
          display: flex
          justify-content: center
          margin-top: 40px
          .input
            display: flex
            justify-content: center
            width: 250px
            height: 50px
            border: 1px solid #D7B375
            color: $primary3
            font-size: 16px
            text-align: center
            outline: none
            margin: 0 auto
            cursor: pointer
.textarea-input
  resize: none
  outline: none
  width: 100%
  height: 80px
  border: none
  font-size: 14px
  &::-webkit-input-placeholder  /* WebKit, Blink, Edge */
    color: #bbbec4
    font-size: 12px
  &:-moz-placeholder  /* Mozilla Firefox 4 to 18 */
    color: #bbbec4
    font-size: 12px
  &::-moz-placeholder  /* Mozilla Firefox 19+ */
    color: #bbbec4
    font-size: 12px
  &:-ms-input-placeholder /* Internet Explorer 10-11 */
    color: #bbbec4
    font-size: 12px
  &.work-experience-input
    height: 200px
  &.achievements-input
    height: 200px
  &.study-experience-input
    height: 200px

.input-extra
  // float: right
  font-size: 14px
  color: #bbbec4
// slot 相关
.subTitle
  margin: -15px 0 12px 14px
  font-size: 14px
  color: #888
.job_remark
  display: flex
  padding-left: 50px
  span
    flex: none
    width: 80px
    line-height: 34px
</style>
